import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/AppList.css';
import SalespersonSidebar from "./SalespersonSidebar";
// import { useMockServer } from '@mui/x-data-grid-generator';

 
const columns = [
  
  { field: 'U.first_name', headerName: 'First Name',cellClassName:'first_name_column',headerClassName:'first_name_header', width: 200,renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.first_name}
      </Link>
    )},
  { field: 'U.last_name', headerName: 'Last Name',cellClassName:'last_name_column',headerClassName:'last_name_header',renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.last_name}
      </Link>
    )},

  
  { field: 'UA.field_date_of_app', headerName: '	Date Of App',cellClassName:'date_of_app_column',headerClassName:'date_of_app_header' },
  {
    field: 'UA.field_user_assignment',
    headerName: 'Salesperson',cellClassName:'salesperson_column',headerClassName:'salesperson_header',
    renderCell: (params) => (
      <Link href={params.row.salesperson_url} target="_blank" rel="noopener noreferrer"  style={{ color: "#2C99D2"}}>
        {params.row.salesperson}
      </Link>
    ),
    sortable: false
  },
];

const AppList =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 10 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const[salespersonList, setSalespersonList] = useState({});
  const [statelist, setStateList] = useState({});
  const [countrieslist, setCountriesList] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [firstnamestartswith, setFirstNameStartsWith] = useState('');
  const [lastnamestartswith, setLastNameStartsWith] = useState('');
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
        field_first_name_value: '',
        field_last_name_value:'',
        first_name_starts_with:'',
        last_name_starts_with:'',
        rid: '',
        mail: '',
        state: '',
        country:'',
        salesperson: '',
        phone:'',
        city:''
    });
  const [appliedFormData, setAppliedFormData] = useState({
        field_first_name_value: '',
        field_last_name_value:'',
        first_name_starts_with:'',
        last_name_starts_with:'',
        rid: '',
        mail: '',
        state: '',
        country:'',
        salesperson: '',
        phone:'',
        city:''
    });
const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };  

    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      try {
         setIsLoading(true);
      const response = await fetch(app_url+'user/getapplist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:appliedFormData,
           first_name_starts_with: firstnamestartswith,
          last_name_starts_with: lastnamestartswith
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

  React.useEffect(() => {

    fetchData();
  }, [paginationModel, filterModel, sortModel, appliedFormData]); // Re-fetch data when these change


  /* Pagination, filter config ends here */
  useEffect(() => {
     
      getsalespersonlist();
      retrieveStateList();
       retrieveCountriesList();
    },[]);
    
 async function getsalespersonlist() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
   async function retrieveCountriesList() {
     try {
      
    const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const countrieslistdata = await countrieslistresponse.json();
    const countrieslist = {};
    Object.keys(countrieslistdata.data.result).forEach(function(key) {
      countrieslist[key] = countrieslistdata.data.result[key];
    });
    setCountriesList(countrieslist);
    } catch (error) {
        console.error(error);
      }finally {
           
          }
  }
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setAppliedFormData({ ...formData });
//   try {
//         setIsLoading(true);
//         setPaginationModel({
//           page: 0,
//           pageSize: 10,
//         });
//       const response = await fetch(app_url+'user/getapplist', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           // page: paginationModel.page,
//           page: 0,
//           pageSize: paginationModel.pageSize,
//           sortModel,
//           filterModel,
//           formData:formData,
//           first_name_starts_with: firstnamestartswith,
//           last_name_starts_with: lastnamestartswith
//         }),
//       });
//       const data = await response.json();
//       console.log(data.data.rows);
//       setRows(data.data.rows);
//       setRowCount(data.data.totalRowCount); // Server should return totalRowCount
//   }catch (error) {
//             console.error('Error fetching data:', error);
//           } finally {
//             setIsLoading(false); // Set loading to false after fetch completes (success or error)
//           }
// }; 
const handleSubmit = (e) => {
  e.preventDefault();
  setPaginationModel((prev) => ({
    ...prev,
    page: 0,
  }));
  setAppliedFormData({ ...formData });
};

const handleClear = (e) => {
  e.preventDefault();
  setformData({});
  setAppliedFormData({});
  setFirstNameStartsWith('');
  setLastNameStartsWith('');
  setSortModel([]);
  setFilterModel({ items: [] });
  setPaginationModel((prev) => ({
    ...prev,
    page: 0,
  }));
};
//  const handleClear = async (e) => {
//   e.preventDefault();
//   setformData({});
//   setAppliedFormData({});
//   setFirstNameStartsWith('');
//   setLastNameStartsWith('');
//   setSortModel([]);
//   setFilterModel({items: []});
//  try {
//          setIsLoading(true);
//         const response = await fetch(app_url+'user/getapplist', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           page: paginationModel.page,
//           pageSize: paginationModel.pageSize,
//         }),
//       });
//       const data = await response.json();
      
//       setRows(data.data.rows);
//       setRowCount(data.data.totalRowCount); // Server should return totalRowCount
//        }catch (error) {
//             console.error('Error fetching data:', error);
//           } finally {
//             setIsLoading(false); // Set loading to false after fetch completes (success or error)
//           }
// }; 
const handleClick = async (field,value) => {
   try {
         setIsLoading(true);
         if(field == "first_name_starts_with") {
          setFirstNameStartsWith(value);
          setLastNameStartsWith('');
         } 
          if(field == "last_name_starts_with") {
          setLastNameStartsWith(value);
           setFirstNameStartsWith('');
         }

      const newPage = 0;
      setPaginationModel((prev) => ({ ...prev, page: newPage }));

      const response = await fetch(app_url+'user/getapplist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          // page: paginationModel.page,
          page: newPage,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:formData,
           [field]:value
        }),
      });
      const data = await response.json();
      
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
       }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    return(
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
            <Helmet><title>User list</title></Helmet>
            <div class="left"></div>
               
               <div class="center left-center">
                <h1>Applicants</h1>
                    <div className="manage_people-container app-list">
                        <div className="manage_people-view-header">
                             <div className="header-actions">
                                
                                <a href="/user-advance-search" className="form-submit manage_people_advancedsearch"  target="_blank" rel="noopener noreferrer">
                                Advanced Search
                                </a>
                            </div>                         
                         </div>
                           <div className="manage_people-view-filters">
                                <form id="views-exposed-form-sa-admin-user-list-page">
                                    <div className="manage_people-views-exposed-form">
                                    <div className="manage_people-views-exposed-widgets">
                                        
                                        {/* Salesperson */}
                                        <div
                                        id="edit-field-salesperson-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-salesperson_value"
                                        >
                                        <label htmlFor="edit-salesperson-value">Sales Person</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <select className="manage_people-form-select" id="salesperson" name="salesperson" value={formData.salesperson} onChange={handleChange}>
                                                <option value="All">- All Sales People -</option>
                                                {salespersonList.length > 0 && (
                                                <>
                                                    {salespersonList.map((item, index) => {
                                                    return <>
                                                    {item['uid'] != null && (
                                                        <><option value={item['uid']}>{item['name']}</option></>
                                                    )}
                                                </>
                                                })}  
                                                </>
                                                )}
                                            </select>
                                            </div>
                                        </div>
                                        </div>
                                        
                                         {/* Roles */}
                                        <div
                                        id="edit-rid-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-rid"
                                        >
                                        <label htmlFor="edit-rid">Roles</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <select id="edit-rid" name="rid" className="manage_people-form-select" value={formData.rid} onChange={handleChange}>
                                                <option value="All">- Any -</option>
                                                <option value="5">scout</option>
                                                <option value="6">agent</option>
                                                <option value="11">athlete</option>
                                                
                                                <option value="27">Global Ambassador</option>
                                            </select>
                                            </div>
                                        </div>
                                        </div>


                                        {/* First Name */}
                                        <div
                                        id="edit-field-first-name-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_first_name_value"
                                        >
                                        <label htmlFor="edit-field-first-name-value">First Name</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-first-name-value"
                                                name="field_first_name_value"
                                                size="30"
                                                maxLength="128"
                                                className="manage_people-form-text" onChange={handleChange} 
                                                value={formData.field_first_name_value}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/* Last Name */}
                                        <div
                                        id="edit-field-last-name-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_last_name_value"
                                        >
                                        <label htmlFor="edit-field-last-name-value">Last Name</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-last-name-value"
                                                name="field_last_name_value"
                                                size="30"
                                                maxLength="128"
                                                className="manage_people-form-text" onChange={handleChange} 
                                                value={formData.field_last_name_value}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                       
                                       
                                        <div className="clear"></div>
                                        {/* E-mail */}
                                        <div
                                        id="edit-mail-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-mail"
                                        >
                                        <label htmlFor="edit-mail">E-mail</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-mail"
                                                name="mail"
                                                size="30"
                                                maxLength="128"
                                                value={formData.mail}
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/*Phone */}
                                        <div
                                        id="edit-field-phone-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_phone_value"
                                        >
                                        <label htmlFor="edit-field-phone-value">Phone</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-phone-value"
                                                name="phone"
                                                size="30"
                                                maxLength="128"
                                                value={formData.phone}
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                         {/*City */}
                                        <div
                                        id="edit-field-city-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_city_value"
                                        >
                                        <label htmlFor="edit-field-city-value">City</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-city-value"
                                                name="city"
                                                size="30"
                                                maxLength="128"
                                                value={formData.city}
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                         {/*State */}
                                        <div
                                        id="edit-field-state-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_state_value"
                                        >
                                        <label htmlFor="edit-field-state-value">State</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                           <select  id="state" name="state" value={formData.state}  onChange={handleChange} >
                                            <option value="">Any</option>
                                            {Object.keys(statelist).map(state => {
                                                return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                                             })}
                                            </select>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="clear"></div>
                                      <div
                                        id="edit-field-state-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_state_value"
                                        >
                                        <label htmlFor="edit-field-state-value">Country</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                          <select name="country" id="country" value={formData.country} onChange={handleChange}>
                                               <option value="">Select Country</option>
                                              {Object.keys(countrieslist).map(item => {
                                              return <option key={countrieslist[item].label} value={countrieslist[item].label}>{countrieslist[item].label}</option>
                                                })}
                                          </select>
                                          </div>
                                          </div>
                                        </div>
                                      
                                        {/* Submit Button */}
                                        
                                        
                                        <div className="manage_people-views-exposed-widget manage_people-views-submit-button">
                                        
                                        <button className='form-submit manage_people-formsubmit' type="submit" onClick={handleSubmit}>Apply</button>
                                        <button className='form-submit manage_people-formsubmit' type="submit" onClick={handleClear}>Clear</button>
                                        </div>

                                    </div>
                                    </div>
                                    <div class="app-filter">
                                        List Applicants by First Name:<br />  
        <a href onClick={()=>handleClick('first_name_starts_with','A')}>A</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','B')}>B</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','C')}>C</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','D')}>D</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','E')}>E</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','F')}>F</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','G')}>G</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','H')}>H</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','I')}>I</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','J')}>J</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','K')}>K</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','L')}>L</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','M')}>M</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','N')}>N</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','O')}>O</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','P')}>P</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','Q')}>Q</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','R')}>R</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','S')}>S</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','T')}>T</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','U')}>U</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','V')}>V</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','W')}>W</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','X')}>X</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','Y')}>Y</a>&nbsp;
        <a href onClick={()=>handleClick('first_name_starts_with','Z')}>Z</a>&nbsp;
      </div>
      <div class="app-filter">
        List Applicants by Last Name:<br/>  
        <a href onClick={()=>handleClick('last_name_starts_with','A')}>A</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','B')}>B</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','C')}>C</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','D')}>D</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','E')}>E</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','F')}>F</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','G')}>G</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','H')}>H</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','I')}>I</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','J')}>J</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','K')}>K</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','L')}>L</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','M')}>M</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','N')}>N</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','O')}>O</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','P')}>P</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Q')}>Q</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','R')}>R</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','S')}>S</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','T')}>T</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','U')}>U</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','V')}>V</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','W')}>W</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','X')}>X</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Y')}>Y</a>&nbsp;
        <a href onClick={()=>handleClick('last_name_starts_with','Z')}>Z</a>&nbsp;
      </div>
                                </form>
                              </div>
                      <div class="heading">Application Management</div>
                        <div className="manage_people-view-content">
                            <table className="app-list-view-table">
                                   <div style={{ width: '100%' }}>
                                    <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    rowCount={rowCount}
                                    paginationMode="server"
                                    sortingMode="server"
                                    filterMode="server"
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    // onSortModelChange={setSortModel}
                                    onSortModelChange={(newModel) => {
                                      setSortModel(newModel);
                                      setPaginationModel((prev) => ({ ...prev, page: 0 }));
                                    }}
                                    filterModel={filterModel}
                                    onFilterModelChange={setFilterModel}
                                    pageSizeOptions={[5, 10, 25,50]}
                                    getRowId={() => crypto.randomUUID()}
                                    getRowHeight={() => 'auto'}
                                    disableColumnFilter 
                                    disableColumnResize={true}
                                />
    </div>
                            </table>
                        </div>

                    </div>

                
        </div>
       <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
        
     )}
    </>
  )
};

export default AppList;